import { useAuth } from '../context/AuthContext';
import { useLocation } from 'react-router-dom';

const Header = ({ onMenuClick }) => {
    const { user } = useAuth();
    const location = useLocation();

    // Get page title based on current route
    const getPageTitle = () => {
        const path = location.pathname;
        switch (path) {
            case '/dashboard':
                return 'Dashboard';
            case '/analytics':
                return 'Analytics';
            case '/widgets':
                return 'Widgets';
            case '/create-widget':
                return 'Create Widget';
            default:
                return 'Dashboard';
        }
    };

    return (
        <header className="bg-white border-b border-secondary-100">
            <div className="flex items-center justify-between px-6 py-4">
                {/* Mobile menu button */}
                <button
                    type="button"
                    className="lg:hidden p-2 rounded-xl text-secondary-500 hover:text-secondary-700 hover:bg-soft-gray focus:outline-none focus:ring-2 focus:ring-primary-500 transition-colors duration-200"
                    onClick={onMenuClick}
                >
                    <span className="sr-only">Open sidebar</span>
                    <svg
                        className="h-6 w-6"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M4 6h16M4 12h16M4 18h16"
                        />
                    </svg>
                </button>

                {/* Title */}
                <div className="flex-1 min-w-0 lg:ml-0 ml-4">
                    <h1 className="text-2xl font-bold leading-7 text-secondary-900 sm:truncate">
                        {getPageTitle()}
                    </h1>
                </div>

                {/* User info */}
                <div className="flex items-center space-x-4">
                    <div className="flex items-center space-x-3">
                        <div className="flex-shrink-0">
                            <div className="h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center">
                                <span className="text-sm font-semibold text-black">
                                    {user?.name?.charAt(0)?.toUpperCase() || 'U'}
                                </span>
                            </div>
                        </div>
                        <div className="hidden md:block">
                            <div className="text-sm font-semibold text-secondary-900">
                                {user?.name || 'User'}
                            </div>
                            <div className="text-sm text-secondary-500">
                                {user?.email || ''}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header; 